import reportInstance from '../instance'

export const getRecordsFormat2ZDateVZip = (dateFrom, dateTo) => {
	return reportInstance.get('/zdatev-v4/zip?'
		+ (dateFrom ? 'dateFrom=' + dateFrom : '')
		+ (dateTo ? '&dateTo=' + dateTo : ''),
		{ responseType: 'arraybuffer' })
}

export default getRecordsFormat2ZDateVZip
